import moment, {Moment} from 'moment';
import {InjectorProvider} from '../injector-provider';
import {TimestampPipe} from './timestamp.pipe';

export function roundToQuarterHour(timestamp) {
  if (timestamp) {
    const roundedTime = moment(timestamp);
    roundedTime.set({minutes: Math.round(roundedTime.minutes() / 15) * 15});
    return roundedTime.toISOString();
  }
  return timestamp;
}

export function roundToNearestQuarterMoment(time: Moment): Moment {
  let minute = time.minute() % 15;
  return minute <= 7 ? time.subtract(minute, "minute") : time.add(15 - minute, "minute");
}

export function formatTimestamp(value: any, format?) {
  if (!timestampPipe) {
    timestampPipe = InjectorProvider.injector.get(TimestampPipe);
  }
  return value ? timestampPipe.transform(value, format) : '';
}

let timestampPipe;
